import { IAppSettings } from "../configuration/appsettings";

export interface IRouter {
  canVisit(pathname?: string): boolean;
  redirectToLegacy(): void;
}

export default class Router implements IRouter {
  private readonly _appSettings: IAppSettings;

  constructor(appSettings: IAppSettings) {
    this._appSettings = appSettings;
  }

  canVisit = (pathname?: string): boolean => {
    const allowedRoutes = this._appSettings.ALLOWED_ROUTES;

    let valid = false;

    if (allowedRoutes) {
      const routes = JSON.parse(allowedRoutes);

      if (!pathname) {
        pathname = window.location.pathname;
      }

      if (routes.includes("/") && pathname == "/") {
        valid = true;
      } else {
        const pathParts = pathname.split("/");

        if (routes.includes(pathParts[1])) {
          valid = true;
        }
      }
    } else {
      valid = true;
    }

    return valid;
  };

  redirectToLegacy = () => {
    window.location.assign(this._appSettings.LEGACY_CD_URL_PROTECTED);
  };
}
